import Link from "next/link";
import Picture from "@/components/common/picture/Picture";
import { dehydrate, QueryClient, useQuery } from "@tanstack/react-query";
import { ApiResponseType, BlogType } from "@/types";
import { getBlogsApiCall } from "@/api/Blog";
import dynamic from "next/dynamic";
// import BreadCrumbs from "@/components/common/ui/BreadCrumbs";

const BreadCrumbs = dynamic(() => import("@/components/common/ui/BreadCrumbs"));

export default function Blog() {
  const { data: blogsData } = useQuery<ApiResponseType<BlogType>>({
    queryKey: ["getBlogsApiCall"],
    queryFn: () => getBlogsApiCall(),
  });

  return (
    <main className="main-blog lg:pt-10 pt-24 pb-[100px] bg-main-bg-color">
      <div className="container">
        <div className="blog_wrapper flex flex-col">
          <BreadCrumbs category={"blog"} notCategory />

          <div className="blog_title-wrapper flex flex-col gap-[14px] mt-[54px]">
            <h1 className="blog_title lg:text-3xl text-2xl font-medium tracking-[3px] uppercase">
              Blog
            </h1>
          </div>

          <div className="blog_main-wrapper flex flex-col lg:flex-row lg::justify-between justify-center lg:mt-14 mt-8 xl:items-start items-center flex-wrap 3xl:gap-10 gap-10">
            {blogsData &&
              blogsData.data.map((blogPostData, index) => {
                return (
                  <Link
                    key={index}
                    href={`/blogPage/${blogPostData.id}`}
                    target="_blank"
                    className="blog_item lg:min-w-[415px] min-w-[343px] group/blog_item transition-all duration-300 hover:shadow-main-box-shadow max-w-[520px] flex flex-col 3xl:basis-[30%] basis-1/4"
                  >
                    <div className="blog_item-img lg:max-w-[520px] lg:h-[380px] min-w-[343px] h-[343px] bg-disable-text-color border-[10px] border-white overflow-hidden">
                      <Picture
                        alt="blog-pic"
                        src={blogPostData.attributes.image.data?.attributes.url ?? ""}
                        width={520}
                        height={380}
                        className="min-h-full object-cover bg-center bg-cover "
                      />
                    </div>
                    <div className="blog_item-content flex flex-col items-center justify-center pt-5 pb-7 xl:px-[60px] 2xl:px-[80px] sm:px-[40px] px-4 transition-all duration-300 group-hover/blog_item:bg-white">
                      <div className="blog_divider w-[30px] h-[1px] bg-disable-color transition-all duration-300 group-hover/blog_item:opacity-0"></div>
                      <h3 className="blog_item-title font-medium tracking-[2px] text-center mt-5 mb-3 text-sub-text-color transition-all duration-300 group-hover/blog_item:text-main-text-color group-hover/blog_item:mt-4 uppercase">
                        {blogPostData.attributes.title}
                      </h3>
                      <p className="blog_item-date font-medium text-disable-color group-hover/blog_item:text-accent-color transition-all duration-300">
                        {blogPostData.attributes.date}
                      </p>
                    </div>
                  </Link>
                );
              })}
          </div>
        </div>
      </div>
    </main>
  );
}

export async function getServerSideProps() {
  const queryClient = new QueryClient();

  await queryClient.prefetchQuery({
    queryKey: [getBlogsApiCall.name],
    queryFn: getBlogsApiCall,
  });

  return {
    props: {
      dehydratedState: dehydrate(queryClient),
    },
  };
}
